export const VAT = 1.21;
